export var AUTH_DIALOG_TRANSLATION_KEY = 'auth-dialog';
export var views = {
  LOGIN_VIEW: 'LOGIN_VIEW',
  REGISTER_VIEW: 'REGISTER_VIEW',
  USER_DATA_VIEW: 'USER_DATA_VIEW',
  BASIC_DATA_FORM: 'BASIC_DATA_FORM'
};